(() => {
  angular
    .module('gm.common.controllers')
    .controller('FeedbackFlyoutController', FeedbackFlyoutController);

  function FeedbackFlyoutController(
    $scope,
    $timeout,
    btgFeedback
  ) {
    'ngInject';

    $scope.message = '';
    $scope.isRequestCompleted = false;
    $scope.isRequestFailed = false;

    $scope.$on('gm:flyout-opened', () => {
      $scope.isRequestCompleted = false;
      $scope.isRequestFailed = false;
    });

    this.submitFeedbackForm = () => {
      $scope.isRequestFailed = false;

      return btgFeedback
        .send($scope.message)
        .then(() => {
          $scope.isRequestCompleted = true;
          $scope.message = '';

          $timeout(() => {
            $scope.$emit('gm:flyout-close');
          }, 5000);
        });
    };
  }
})();
